export { default } from './GlobalFooterContainer';
